import React, {useEffect, useState} from 'react';
import axios from "axios";
import {useLocation} from 'react-router-dom';
import {Page, Spinner, Banner} from "@shopify/polaris";
import {Loading} from '@shopify/app-bridge-react';

import {getAxiosErrorMessage, isUnauthorized, apiOrigin} from "../util/AxiosUtil";

type LoginProps = {
    onSuccess: () => void
}

export default function Login({onSuccess} : LoginProps) {
    const location = useLocation();
    const [ loading, setLoading ] = useState(true);
    const [ errorMessage, setErrorMessage ] = useState<string | null>(null);

    const doLogin = () => {
        axios.post(`/shopify/v1/auth/login${location.search}`)
            .then(response => {
                onSuccess();
            }).catch(axiosError => {
                if (isUnauthorized(axiosError)) {
                    // UNAUTHORIZED (status 401) indicates this shop is not authorized
                    // in SubTrux so redirect to oauth flow passing query params
                    window.location.href = apiOrigin() + "/shopify/v1/auth" + location.search;
                } else {
                    setErrorMessage(getAxiosErrorMessage(axiosError));
                }
            }).finally(() => {
                setLoading(false);
            });
    };

    useEffect(() => {
        doLogin();
    }, []); // eslint-disable-line react-hooks/exhaustive-deps
    // passing an empty array as second argument triggers the callback in useEffect only after the initial render thus replicating `componentDidMount` lifecycle behaviour

    return (
        <Page>
            {loading &&
            <>
                <Loading />
                <Spinner accessibilityLabel="Loading App" size="large" />
            </>}
            {errorMessage &&
            <Banner
                title="Unable to initiate session"
                status="critical"
            >
                <>
                    <p>SubTrux was unable to setup a new session which is rare so something critical must have happened. The reason for this is displayed below however
                        you can retry this by exiting the app in Shopify and then re-accessing it.</p>
                    <p>REASON: {errorMessage}</p>
                </>
            </Banner>
            }
        </Page>
    );
};